"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTargetWidth = exports.resizeColumnsRight = exports.resizeColumnSingle = exports.normalizeColumnBorders = exports.removeColumn = exports.addColumn = exports.MIN_WIDTH = void 0;
var lodash_1 = __importDefault(require("lodash"));
exports.MIN_WIDTH = 5;
var addColumn = function (columnBorderIdx, _columnBorders) {
    var columnBorders = lodash_1.default.cloneDeep(_columnBorders);
    var targetWidth = (0, exports.calculateTargetWidth)(columnBorderIdx, columnBorders);
    columnBorders.splice(columnBorderIdx, 0, columnBorders[columnBorderIdx]);
    var widths = getColumnWidths(columnBorders);
    if (lodash_1.default.uniq(widths.map(function (x) {
        return Math.round(x);
    })).length == 2) {
        var newWidths = new Array(widths.length).fill(100 / widths.length);
        return getColumnBorders(newWidths);
    }
    var totalGained = 0;
    while (totalGained < targetWidth) {
        var newGains = 0;
        var targetGain = targetWidth - totalGained;
        var spaceToRight = getShrinkableSpaceRight(widths, columnBorderIdx + 1);
        for (var i = columnBorderIdx; i < widths.length; i++) {
            if (widths[i] <= exports.MIN_WIDTH) {
                continue;
            }
            var targetDiff = (targetGain * widths[i]) / spaceToRight;
            var diff = Math.min(targetDiff, widths[i] - exports.MIN_WIDTH);
            widths[i] -= diff;
            newGains += diff;
        }
        totalGained += newGains;
        if (newGains == 0) {
            break;
        }
    }
    while (totalGained < targetWidth) {
        var newGains = 0;
        var targetGain = targetWidth - totalGained;
        var spaceToLeft = getShrinkableSpaceLeft(widths, columnBorderIdx);
        for (var i = 0; i < columnBorderIdx; i++) {
            if (widths[i] <= exports.MIN_WIDTH) {
                continue;
            }
            var targetDiff = (targetGain * widths[i]) / spaceToLeft;
            var diff = Math.min(targetDiff, widths[i] - exports.MIN_WIDTH);
            widths[i] -= diff;
            newGains += diff;
        }
        totalGained += newGains;
        if (newGains == 0) {
            break;
        }
    }
    widths[columnBorderIdx] = totalGained;
    var newBorders = getColumnBorders(widths);
    newBorders[newBorders.length - 1] = 100;
    return newBorders;
};
exports.addColumn = addColumn;
var removeColumn = function (column, columnBorders) {
    var widths = getColumnWidths(columnBorders);
    var gainedSpace = widths[column];
    if (lodash_1.default.uniq(widths.map(function (x) {
        return Math.round(x);
    })).length == 1) {
        var newWidths = new Array(widths.length - 1).fill(100 / (widths.length - 1));
        return getColumnBorders(newWidths);
    }
    var spaceToRight = 100 - columnBorders[column + 1];
    if (spaceToRight > 0) {
        for (var i = column + 1; i < widths.length; i++) {
            widths[i] += (gainedSpace * widths[i]) / spaceToRight;
        }
    }
    else {
        var spaceToLeft = 100 - gainedSpace;
        for (var i = 0; i < column; i++) {
            widths[i] += (gainedSpace * widths[i]) / spaceToLeft;
        }
    }
    widths.splice(column, 1);
    var newBorders = getColumnBorders(widths);
    newBorders[newBorders.length - 1] = 100;
    return newBorders;
};
exports.removeColumn = removeColumn;
var normalizeColumnBorders = function (columns, columnBorders) {
    if (!columnBorders || columnBorders.length != columns + 1) {
        return resetColumnBorders(columns);
    }
    for (var i = 1; i < columnBorders.length; i++) {
        if (columnBorders[i] <= columnBorders[i - 1]) {
            return resetColumnBorders(columns);
        }
    }
    if (columnBorders[0] != 0 || columnBorders[columnBorders.length - 1] != 100) {
        return resetColumnBorders(columns);
    }
    return columnBorders;
};
exports.normalizeColumnBorders = normalizeColumnBorders;
var resizeColumnSingle = function (columnBorderIdx, newPosition, columnBorders) {
    if (newPosition < columnBorders[columnBorderIdx - 1] + exports.MIN_WIDTH) {
        newPosition = columnBorders[columnBorderIdx - 1] + exports.MIN_WIDTH;
    }
    if (newPosition > columnBorders[columnBorderIdx + 1] - exports.MIN_WIDTH) {
        newPosition = columnBorders[columnBorderIdx + 1] - exports.MIN_WIDTH;
    }
    columnBorders[columnBorderIdx] = newPosition;
    return columnBorders;
};
exports.resizeColumnSingle = resizeColumnSingle;
var resizeColumnsRight = function (columnBorderIdx, newPosition, columnBorders) {
    var widths = getColumnWidths(columnBorders);
    var targetDiff = newPosition - columnBorders[columnBorderIdx];
    targetDiff = Math.max(targetDiff, exports.MIN_WIDTH - widths[columnBorderIdx - 1]);
    var totalGained = 0;
    while (Math.abs(totalGained) < Math.abs(targetDiff)) {
        var newGains = 0;
        var targetGain = targetDiff - totalGained;
        if (targetDiff > 0) {
            var spaceToRight = getShrinkableSpaceRight(widths, columnBorderIdx);
            for (var i = columnBorderIdx; i < widths.length; i++) {
                if (widths[i] <= exports.MIN_WIDTH) {
                    continue;
                }
                var targetCellDiff = (targetGain * widths[i]) / spaceToRight;
                var diff = Math.min(targetCellDiff, widths[i] - exports.MIN_WIDTH);
                widths[i] -= diff;
                newGains += diff;
            }
            totalGained += newGains;
            if (newGains == 0) {
                break;
            }
        }
        else {
            var spaceToRight = 100 - columnBorders[columnBorderIdx];
            for (var i = columnBorderIdx; i < widths.length; i++) {
                var targetDiff_1 = (targetGain * widths[i]) / spaceToRight;
                var diff = targetDiff_1;
                widths[i] -= diff;
                newGains += diff;
            }
            totalGained += newGains;
            if (newGains == 0) {
                break;
            }
        }
    }
    widths[columnBorderIdx - 1] += totalGained;
    var newBorders = getColumnBorders(widths);
    return newBorders;
};
exports.resizeColumnsRight = resizeColumnsRight;
var calculateTargetWidth = function (columnBorderIdx, columnBorders) {
    var targetWidth = exports.MIN_WIDTH;
    var columnsToRight = columnBorders.length - 1 - columnBorderIdx;
    if (columnsToRight == 0) {
        targetWidth = 100 / columnBorders.length;
    }
    else {
        var spaceToRight = 100 - columnBorders[columnBorderIdx];
        targetWidth = Math.max(exports.MIN_WIDTH, spaceToRight / (columnsToRight + 1));
    }
    return targetWidth;
};
exports.calculateTargetWidth = calculateTargetWidth;
var resetColumnBorders = function (columns) {
    var widths = new Array(columns).fill(100 / columns);
    return getColumnBorders(widths);
};
var getColumnWidths = function (columnBorders) {
    var widths = [];
    for (var i = 1; i < columnBorders.length; i++) {
        widths.push(columnBorders[i] - columnBorders[i - 1]);
    }
    return widths;
};
var getColumnBorders = function (columnWidths) {
    var columnBorders = [0];
    for (var i = 0; i < columnWidths.length; i++) {
        columnBorders.push(columnWidths[i] + columnBorders[i]);
    }
    columnBorders[columnBorders.length - 1] = 100;
    return columnBorders;
};
var getShrinkableSpaceRight = function (columnWidths, column) {
    var space = 0;
    for (var i = column; i < columnWidths.length; i++) {
        if (columnWidths[i] <= exports.MIN_WIDTH) {
            continue;
        }
        space += columnWidths[i];
    }
    return space;
};
var getShrinkableSpaceLeft = function (columnWidths, column) {
    var space = 0;
    for (var i = 0; i < column; i++) {
        if (columnWidths[i] <= exports.MIN_WIDTH) {
            continue;
        }
        space += columnWidths[i];
    }
    return space;
};
